import { v4 as uuidv4 } from 'uuid';
import { axios } from '../axios';
import { useMutation } from '@tanstack/react-query';
import { ExtractFnReturnType } from 'apis/queryConfig';
import { AxiosResponse } from 'axios';


type IDownloadActionTrackerLoadsheet= {
    project_id: string;
    asset_id: string | null;
    params?: { [key: string]: any; }
}
export async function DownloadActionTrackerLoadsheet({project_id, asset_id, params}: IDownloadActionTrackerLoadsheet): Promise<AxiosResponse<Blob>> {
    return axios.get(`oe/action-management/project/${project_id}/asset/${asset_id}/loadsheet`, {
        params,
        responseType: 'blob',
    })
}
export type DownloadActionTrackerLoadsheet = ExtractFnReturnType<typeof DownloadActionTrackerLoadsheet>

export const useActionTrackerLoadsheetDownload = () => {
    return useMutation<DownloadActionTrackerLoadsheet, Error, IDownloadActionTrackerLoadsheet>({
        mutationKey: ['actionTrackerLoadsheetDownload'],
        mutationFn: (data) => DownloadActionTrackerLoadsheet(data),
    })
}